import { Comparable } from "@siteimprove/alfa-comparable";
/**
 * @public
 */
export var Encapsulation;
(function (Encapsulation) {
    Encapsulation.compare = Comparable.compareNumber;
})(Encapsulation || (Encapsulation = {}));
//# sourceMappingURL=encapsulation.js.map